/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('portingstatus').controller('portingStatusCtrl', [ '$rootScope', '$scope', '$http', '$injector', '$state', '$stateParams', '$compile', 'mnpNbaProvider', 'orderStatusInportService', 'trackingSrv', function($rootScope, $scope, $http, $injector, $state, $stateParams, $compile, mnpNbaProvider, orderStatusInportService, trackingSrv) {

        var vm = this;
        vm.$onInit = function () {
            vm.config = $injector.get('config');

            vm.authenticated = false;
            $rootScope.loading = true;
            vm.messageUrl = '';

            vm.data = {
                orderId: $stateParams.orderId || null,
                firstname: $stateParams.firstname || null,
                lastname: $stateParams.lastname || null,
            };

            vm.statusResponse = {};
            vm.status = {};

            vm.requestOrderStatus = function() {
                $state.go('porting-status', vm.data);
            };

            vm.init = function() {
                // load the status
                if (vm.data.orderId && vm.data.firstname && vm.data.lastname) {
                    // show the status for given order-id
                    orderStatusInportService.orderStatusByOrderId(vm.data.orderId, vm.data.firstname, vm.data.lastname).then(showOrderStatus, showOrderStatusError);
                } else {
                    // check for msisdn from logged in user
                    mnpNbaProvider.checkSession().then(function() {
                        vm.authenticated = true;
                        if (window.portingUser.MSISDN && window.portingUser.BAN) {
                            orderStatusInportService.orderStatusByMSISDN(window.portingUser.MSISDN, window.portingUser.BAN).then(showOrderStatus, showOrderStatusError);
                        } else {
                            trackingSrv.trackError('', trackingSrv.E_TYPE_NOTIFICATION, 'missing msisdn and ban', $state.current.url);
                            showMessagePartialByUrl(vm.config.messagePartialURLs.internalErrors.missingCredentials);
                        }
                    });

                }
            };

            /**
             * just an alias to access from view
             */
            vm.logout = function() {
                $rootScope.loading = true;
                mnpNbaProvider.logout();
            };

            function showOrderStatus(response) {
                mapResponseFields(response);
                showStatusPartialByResult(response);
            };

            function showOrderStatusError(response) {
                mapResponseFields(response);
                var url = null; // use default if nothing will be set

                if (response.data.responseCode) {
                    var parts = response.data.responseCode.split('.');
                    var errorCode = parts[2] + '.' + parts[3];
                    var definedErrorList = [ '400.7', '401.3', '401.4'
                    ];
                    if ('400.8' === errorCode) {
                        url = vm.config.messagePartialURLs.internalErrors.early;
                    } else if (-1 !== definedErrorList.indexOf(errorCode)) {
                        url = vm.config.partialsBaseUrl + '/status/messages/porting.error.' + errorCode + '.html';
                    } else {
                        //use default error
                    }
                    trackingSrv.trackError(response.data.responseCode, trackingSrv.E_TYPE_NOTIFICATION, response.data.description, $state.current.url);
                } else {
                    trackingSrv.trackError('', trackingSrv.E_TYPE_TECHNICAL, 'error at status request', $state.current.url);
                }
                showMessagePartialByUrl(url);
            };

            /**
             * show a partial for given statuscode from cms
             */
            function showStatusPartialByResult(response) {
                var url = null;
                var orderStatus = response.data.order_status || null; // eslint-disable-line camelcase

                if (response.data && response.data.getStatusInportResult.STATUS) {
                    // show status from KIAS
                    url = vm.config.messagePartialURLs.cmsBaseUrl + vm.config.messagePartialURLs.cmsFilePrefix + response.data.getStatusInportResult.STATUS.toLowerCase();
                    if (response.data.getStatusInportResult.ERRORCODE) {
                        url = url + '-' + response.data.getStatusInportResult.ERRORCODE.substring(response.data.getStatusInportResult.ERRORCODE.length - 4);
                    }
                    url = url + '.html';
                } else {
                    // show status from ePos if no KIAS status was found
                    if ('Erfolgreich an D2 uebermittelt' === orderStatus) {
                        url = vm.config.messagePartialURLs.messages.uebermittelt;
                    } else if ('Bereit zur Bonitaetspruefung' === orderStatus) {
                        url = vm.config.messagePartialURLs.messages.bonitaet;
                    } else if ('Manuelle Pruefung' === orderStatus) {
                        url = vm.config.messagePartialURLs.messages.manuell;
                    } else if ('erledigt' === orderStatus) {
                        url = vm.config.messagePartialURLs.messages.erledigt;
                    } else if ('Export gebucht' === orderStatus) {
                        url = vm.config.messagePartialURLs.messages.export;
                    } else {
                        //default message for ePos status if nothing special is defined above
                        url = vm.config.messagePartialURLs.messages.default;
                    }
                }

                showMessagePartialByUrl(url);
            };

            /**
             * show a partial with given URL
             */
            function showMessagePartialByUrl(url) {
                var defaultUrl = vm.config.messagePartialURLs.internalErrors.error;
                url = url || defaultUrl;
                vm.messageUrl = url;
                $rootScope.loading = false;
            };

            /**
             * create plain field structure for CMS usage
             */
            function mapResponseFields(response) {

                vm.statusResponse = response.data;
                vm.status = {};
                vm.status.RESPONSECODE = response.data.responseCode;

                if (response.data.getStatusInportResult) {

                    if (response.data.getStatusInportResult.PORTINGDATE) {
                        var d = new Date(response.data.getStatusInportResult.PORTINGDATE);
                        var day = 10 > d.getDate() ? '0' + d.getDate() : d.getDate();
                        var month = 9 > d.getMonth() ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
                        vm.status.BP_PORTING_DATE = day + '.' + month + '.' + d.getFullYear();
                    } else {
                        vm.status.BP_PORTING_DATE = '';
                    }

                    // the MSISDN from backend is the ported msisdn, not the VF MSISDN
                    vm.status.BP_PORTED_MSISDN = response.data.getStatusInportResult.MSISDN ? response.data.getStatusInportResult.MSISDN.replace('GSM', '0') : '';
                    vm.status.VF_MSISDN = response.data.getStatusInportResult.BELATEDPORTINGSUBSCRIBER ? response.data.getStatusInportResult.BELATEDPORTINGSUBSCRIBER.replace('GSM', '0') : '';
                }

            }
        };
    }
    ]);

})();
